

export const SOCKET = {
  ADJUDICATOR: "adjudicator",
  ADJUDICATOR_LOG_IN: "adjudicatorLogIn",
  ADJUDICATOR_LOG_OUT: "adjudicatorLogOut",
  ADJUDICATOR_SHEET: "adjudicatorSheet",
  ACK_ADJUDICATOR_SHEET: "ackAdjudicatorSheet",
  ADJUDICATOR_ROUND_RESULTS: "adjudicatorRoundResults",
  ADJUDICATOR_CURRENT_SCREEN: "adjudicatorCurrentScreen",
  JUDGES_LIST: "judgesList",
  TIMETABLE: "timetable",
  TIMETABLE_DETAILS: "timetableDetails",
  MONITOR_DETAILS: "monitorDetails",
  RESET_MONITOR: "resetMonitor",
  MESSAGE: "message",
  TASK_MANAGET_QUEUE: "taskManagerQueue",
  COMPETITION: "competition",
  ADJUDICATOR_WARNING: "adjudicatorWarning",
  MC_LOG_IN: "mcLogIn",
  MONITOR_LOG_IN: "monitorLogIn",
  RESEND_CONST_EMIT: "resendConstEmit",
  // Visual Control Events (LED/Broadcast)
  VISUAL_CONTROLLER_LOG_IN: "visualControllerLogIn",
  LED_LOG_IN: "ledLogIn",
  BROADCAST_LOG_IN: "broadcastLogIn",
  VISUAL_CONTROL: "visualControl",           // Command to change content on LED/Broadcast
  VISUAL_STATE: "visualState",               // Current state broadcast to all controllers
  JUDGES_STATUS: "judgesStatus",             // Judges status updates for chairperson/MC
  TIMER_CONTROL: "timerControl",             // Command to set/start/stop/reset the countdown timer
  TIMER_STATE: "timerState",                 // Current timer state broadcast to all devices
  // Live results (chairperson): request/response scoped to the requesting device's mc room
  LIVE_RESULTS_SUBSCRIBE: "liveResultsSubscribe",     // Chairperson opens results dialog: { deviceUuid, ttUuid }
  LIVE_RESULTS_UNSUBSCRIBE: "liveResultsUnsubscribe", // Chairperson closes results dialog: { deviceUuid, ttUuid }
  LIVE_RESULTS: "liveResults",                        // Pre-calculated results sent to mc:${deviceUuid}: { ttUuid, results }
  // Chairperson warnings: snapshot on subscribe + a per-new-warning push, scoped to mc:${deviceUuid}
  CHAIRPERSON_WARNINGS_SUBSCRIBE: "chairpersonWarningsSubscribe",     // Chairperson connects: { deviceUuid }
  CHAIRPERSON_WARNINGS_UNSUBSCRIBE: "chairpersonWarningsUnsubscribe", // { deviceUuid }
  CHAIRPERSON_WARNINGS: "chairpersonWarnings",                        // Snapshot to mc:${deviceUuid}: { warnings: EnrichedWarning[] }
  CHAIRPERSON_NEW_WARNING: "chairpersonNewWarning",                   // Single new warning to mc:${deviceUuid}: { warning: EnrichedWarning }
  // Breaking bracket for Monitor/MC/Chairperson, one const emit per category:
  // { BreakingBracketView } - see marx BREAKING_BRACKET
  BREAKING_BRACKET: "breakingBracket",
  // Public results address, broadcast as a const emit so it survives reconnects
  // and reaches monitors that join later: { url, label? }
  PUBLIC_RESULTS_URL: "publicResultsUrl",
  // Heartbeat for the desktop's Devices screen, which also heals a lost login:
  // { deviceUuid, deviceId, deviceType, adjudicator, battery, version, bundleId }
  DEVICE_STATUS: "deviceStatus",
  ADJUDICATOR_FORCE_LOG_OUT: "adjudicatorForceLogOut", // Desktop signs this phone's judge out
  IDENTIFY_DEVICE: "identifyDevice",                   // Desktop asks this phone to flash its number: { deviceId }
} as const;

export default SOCKET;
type t = typeof SOCKET;
export type SocketType =  t[keyof t];